export abstract class WorklistStatusProvider {
    abstract isAllowedToChangeStatus(worklist): Promise<boolean>;
    abstract changeStatusPopover(item, $event): Promise<void>;
}